// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3toYR","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2vz2Y"};